export function createCountWithFilters<Item, State>(source: MaybeRefOrGetter<Item[]>, committed: ComputedRef<State>, predicate: (item: Item, state: State) => boolean) {
  return (overrides: Partial<State>): number => {
    const state = { ...committed.value, ...overrides } as State
    const items = toValue(source)
    return items.reduce((count, item) => count + (predicate(item, state) ? 1 : 0), 0)
  }
}
